import React, { useState } from "react";
import { updateAudience } from "../../api/audienceApi";
import { Button, FormField, LottieLoadingIndicator, StandardModal, StandardModalActionGroup, StandardModalFormGroup, StandardModalSection, StandardModalSectionTitle, Toast } from "src/components";
import { TextLabel } from "../style";
import { LoadingIndicatorButton } from "src/scenes/Survey/components/Utils";

export default function UpdateAudienceName(props) {
    const { setShowUpdateAudienceName, selectedAudience, getAllAudience, setSelectedAction } = props;
    const [audienceName, setAudienceName] = useState(selectedAudience.name);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const validate = () => {
        const newErrors = {};
        if (!audienceName) newErrors.audienceName = "Audience name is required";
        return newErrors;
    };

    const onAudienceNameChange = (e) => {
        setAudienceName(e.target.value);
        setErrors({ ...errors, audienceName: "" });
    };
    const handleSubmit = async () => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setIsLoading(true);
        try {
            const payload = {
                name: audienceName,
            };
            const response = await updateAudience(selectedAudience.uuid, payload);
            if (response) Toast.success("Audience has been successfully added.");
            getAllAudience();
            setAudienceName("");
            setShowUpdateAudienceName(false);
            setSelectedAction({});
        } catch (error) {
            setIsLoading(false);
            console.log(error);
            Toast.error(error.getApiErrorDetails().message);
        }
    };
    return (
        <StandardModal
            open={true}
            onClose={() => setShowUpdateAudienceName(false)}
            widthMode="medium"
            title="Updating Audience Name"
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        type="button"
                        width="140px"
                        height="39px"
                        color="#000000"
                        border="1px solid #000"
                        onClick={() => {
                            setSelectedAction({});
                            setShowUpdateAudienceName(false);
                        }}
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Cancel
                    </Button>
                    {isLoading ? (
                        <LoadingIndicatorButton>
                            <LottieLoadingIndicator
                                height="2rem"
                                width="2rem"
                                margin="5px"
                                containerHeight="2rem"
                            />
                        </LoadingIndicatorButton>
                    ) : (
                        <Button
                            type="button"
                            width="140px"
                            height="39px"
                            color="#FFFFFF"
                            backgroundColor="#171A22"
                            border="1px solid #171A22"
                            onClick={() => handleSubmit()}
                            style={{ borderRadius: "7px", boxShadow: "none" }}
                        >
                            Save
                        </Button>
                    )}
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalFormGroup>
                    <StandardModalSectionTitle>Audience Name</StandardModalSectionTitle>
                    <FormField
                        borderRadius="10px"
                        size="14px"
                        height="39px"
                        border={errors.audienceName ? "1px solid red" : "1px solid #D8DEEC"}
                        backgroundColor={"#FFFFFF 0% 0% no-repeat padding-box"}
                        boxShadow="0px 3px 6px #00000029"
                        opacity="1"
                        align="left"
                        type="text"
                        placeholder={"Audience Name"}
                        placeholderColor="#808080"
                        placeholderSize="14px"
                        onChange={onAudienceNameChange}
                        showErrors={true}
                        maxLength="100"
                        value={audienceName}
                        name="audienceName"
                        width="100%"
                    />
                    <TextLabel color="red" style={{ marginTop: -10 }}>
                        {errors.audienceName}
                    </TextLabel>
                </StandardModalFormGroup>
            </StandardModalSection>
        </StandardModal>
    );
}
